
// DefualtColour services rest api calling

import { routes } from '../config/api_routes'

export const defualtColourServices = {

    // get DefualtColour 
    // info: sortDesc : Boolean
    
    getDefualtColour: (formData) => window.axios.post(routes.getDefualtColourApi,formData),

    // add DefualtColour Type 

    addDefualtColour: (formData) => window.axios.post(routes.addDefualtColourApi,formData),

    // get DefualtColourById 

    getDefualtColourById: (formData) => window.axios.post(routes.getDefualtColourApiById,formData),

    // update DefualtColourById

    updateDefualtColourById: (formData) => window.axios.post(routes.updateDefaultColourApi,formData),

    // delete DefualtColourById

    deleteDefualtColourById: (formData) => window.axios.post(routes.deleteDefaultColourApi,formData),
}